import { PagarMisProductosComponent } from './pages/pagar-mis-productos/pagar-mis-productos.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrintHtmlComponent } from './components/print-html/print-html.component';
import { CambiarClaveUsuarioComponent } from './pages/cambiar-clave-usuario/cambiar-clave-usuario.component';
import { ClaveTemporalComponent } from './pages/clave-temporal/clave-temporal.component';
import { FirmaElectronicaComponent } from './pages/firma-electronica/firma-electronica.component';
import { IdentifyComponent } from './pages/identify/identify.component';
import { MisDatosComponent } from './pages/mis-datos/mis-datos.component';
import { ProductosComponent } from './pages/productos/productos.component';
import { RecuperarClaveComponent } from './pages/recuperar-clave/recuperar-clave.component';
import { LogOutComponent } from './pages/log-out/log-out.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { InvAuthGuard } from './shared/guards/inv-auth.guard';
import { paths, productosPath } from './shared/helpers/constants';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { MonitoringInterceptor } from './shared/interceptors/monitoring.interceptor';
import { InformeRentabilidadComponent } from './pages/informe-rentabilidad/informe-rentabilidad.component';
import { PolizaGuard } from './shared/guards/poliza.guard';
import { LoginComponent } from './pages/login/login.component';
import { LoginSsoComponent } from './pages/login-sso/login-sso.component';
import { PageView, getValuePageView } from './shared/enums/insights/page-view';
import { ComprobanteTokuComponent } from './pages/comprobante-toku/comprobante-toku.component';

const routes: Routes = [
  {
    path: paths.identify.path,
    component: IdentifyComponent,
    canActivate: [InvAuthGuard],
  },
  {
    path: paths.root.path,
    redirectTo: productosPath.path,
    pathMatch: 'full',
    canActivate: [AuthGuard],
  },
  {
    path: productosPath.path,
    component: ProductosComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: productosPath.children.individual.path,
        loadChildren:
          './modules/seguro-individual/seguro-individual.module#SeguroIndividualModule',
        // import('./modules/seguro-individual/seguro-individual.module').then(
        //   m => m.SeguroIndividualModule
        // ),
        canActivate: [AuthGuard],
      },
      {
        path: productosPath.children.colectivo.path,
        loadChildren:
          './modules/seguro-colectivo/seguro-colectivo.module#SeguroColectivoModule',
        // import('./modules/seguro-colectivo/seguro-colectivo.module').then(
        //   m => m.SeguroColectivoModule
        // ),
        canActivate: [AuthGuard],
      },
      {
        path: productosPath.children.vitalicio.path,
        loadChildren:
          './modules/seguro-vitalicio/seguro-vitalicio.module#SeguroVitalicioModule',
        // import('./modules/seguro-vitalicio/seguro-vitalicio.module').then(
        //   m => m.SeguroVitalicioModule
        // ),
        canActivate: [AuthGuard],
      },
      {
        path: productosPath.children.privado.path,
        loadChildren:
          './modules/seguro-privado/seguro-privado.module#SeguroPrivadoModule',
        // import('./modules/seguro-privado/seguro-privado.module').then(
        //   m => m.SeguroPrivadoModule
        // ),
        canActivate: [AuthGuard],
      },
      {
        path: productosPath.children.salud.path,
        loadChildren:
          './modules/seguro-salud/seguro-salud.module#SeguroSaludModule',
        // import('./modules/seguro-colectivo/seguro-colectivo.module').then(
        //   m => m.SeguroColectivoModule
        // ),
        canActivate: [AuthGuard],
      },
      {
        path: paths.misDatosEmpty.path,
        redirectTo: paths.misDatosEmpty.path + '/',
      },
      {
        path: paths.misDatos.path,
        component: MisDatosComponent,
        canActivate: [AuthGuard],
        data: {
          viewName: PageView.myDataView,
          label: getValuePageView[PageView.myDataView]
        }
      },
      {
        path: paths.firmaElectronica.path,
        component: FirmaElectronicaComponent,
        canActivate: [AuthGuard, PolizaGuard],
        data: {
          viewName: PageView.electronicSignatureView,
          label: getValuePageView[PageView.electronicSignatureView]
        }
      },
      {
        path: paths.cambiarContrasena.path,
        component: CambiarClaveUsuarioComponent,
        canActivate: [AuthGuard],
        data: {
          viewName: PageView.changePasswordView,
          label: getValuePageView[PageView.changePasswordView]
        }
      },
      {
        path: paths.pagarProductos.path,
        component: PagarMisProductosComponent,
        canActivate: [AuthGuard],
        data: {
          viewName: PageView.payMyProductsView,
          label: getValuePageView[PageView.payMyProductsView]
        }
      },
      {
        path: paths.informeRentabilidad.path,
        component: InformeRentabilidadComponent,
        canActivate: [AuthGuard],
        data: {
          viewName: PageView.profitabilityReportView,
          label: getValuePageView[PageView.profitabilityReportView]
        }
      },
    ],
  },
  {
    path: paths.recuperarClave.path,
    component: RecuperarClaveComponent,
    canActivate: [InvAuthGuard],
  },
  {
    path: paths.cerrarSesion.path,
    component: LogOutComponent,
  },
  {
    path: paths.login.path,
    component: LoginComponent,
  },
  {
    path: paths.print.path,
    component: PrintHtmlComponent,
  },

  {
    path: paths.claveTemporal.path,
    component: ClaveTemporalComponent,
  },
  {
    path: paths.loginSso.path,
    component: LoginSsoComponent,
  },
  {
    path: paths.comprobanteToku.path,
    component: ComprobanteTokuComponent,
    canActivate: [InvAuthGuard]
  },
  // {
  //   path: productosPath.children.individual.path,
  //   // loadChildren:
  //   //   './modules/seguro-individual/seguro-individual.module#SeguroIndividualModule',
  //   loadChildren: () => SeguroIndividualModule,
  //   canActivate: [AuthGuard]
  // },
  // {
  //   path: productosPath.children.colectivo.path,
  //   // loadChildren:
  //   //   './modules/seguro-colectivo/seguro-colectivo.module#SeguroColectivolModule',
  //   loadChildren: () => SeguroColectivoModule,
  //   canActivate: [AuthGuard]
  // },
  // {
  //   path: productosPath.children.vitalicio.path,
  //   loadChildren: () => SeguroVitalicioModule,
  //   canActivate: [AuthGuard]
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      relativeLinkResolution: 'corrected' 
      //, enableTracing: true
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MonitoringInterceptor,
      multi: true,
    },
  ],
})
export class AppRoutingModule {}
